import React, { useEffect, useState } from 'react';
import styles from '../tainaraqquel/tainaraqquel.module.scss';
import perfil from '../tainaraqquel/src/perfil.png';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import TiktokIcon from '../../icons/tiktokIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const EMAIL = 'contatotainaraqquel@icloud.com';
const WHATSAPP_NUMBER = '5514996719443';
const INSTAGRAM_URL =
    'https://www.instagram.com/tainaraqquel?utm_source=ig_web_button_share_sheet&igsi=ZDNlZDc0MzIxNw==';
const TIKTOK_URL = 'https://www.tiktok.com/@tainaraqquel?_r=1&_t=ZS-99NO3hy4Fim';
const SHOPEE_URL = 'https://collshp.com/tainaraquel0308187?view=storefront';
const ICON_COLOR = '#faeed9';

type ContactCard = {
    id: number;
    image: string;
    brand: string;
    email: string;
    whatsapp: string;
    modal: 'contact';
};

type CupomCard = {
    id: number;
    image: string;
    brand: string;
    cupom?: string;
    site?: string;
    modal: true;
};

type LinkCard = {
    id: number;
    image: string;
    brand: string;
    link: string;
    modal?: false;
};

type ModalCard = ContactCard | CupomCard;
type CardItem = ContactCard | CupomCard | LinkCard;

const cardImages: CardItem[] = [
    {
        id: 1,
        image: require('./src/cards/1.png'),
        brand: 'Contatos',
        email: EMAIL,
        whatsapp: WHATSAPP_NUMBER,
        modal: 'contact',
    },
    {
        id: 2,
        image: require('./src/cards/2.png'),
        brand: 'Saint Germain',
        modal: true,
    },
    {
        id: 3,
        image: require('./src/cards/3.png'),
        brand: 'Max Fem',
        modal: true,
    },
    {
        id: 4,
        image: require('./src/cards/4.png'),
        brand: 'Aura Beauty',
        cupom: 'TAINA10',
        site: 'https://aurabeautyclub.com.br/discount/TAINA10?utm_source=creatorsclub&utm_medium=&utm_campaign=afiliadas&utm_content=TAINA10',
        modal: true,
    },
    {
        id: 5,
        image: require('./src/cards/5.png'),
        brand: 'SHEIN',
        cupom: '99XM3',
        site: 'https://br.shein.com/',
        modal: true,
    },
    {
        id: 6,
        image: require('./src/cards/6.png'),
        brand: 'Riachuelo',
        modal: true,
    },
    {
        id: 7,
        image: require('./src/cards/7.png'),
        brand: 'Vitrine Shopee',
        link: SHOPEE_URL,
    },
];

const Tainaraqquel: React.FC = () => {
    const [activeCard, setActiveCard] = useState<ModalCard | null>(null);
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        if (!activeCard) return;

        const onKeyDown = (e: KeyboardEvent) => {
            if (e.key === 'Escape') setActiveCard(null);
        };

        const prevOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        window.addEventListener('keydown', onKeyDown);

        return () => {
            document.body.style.overflow = prevOverflow;
            window.removeEventListener('keydown', onKeyDown);
        };
    }, [activeCard]);

    useEffect(() => {
        setCopied(false);
    }, [activeCard]);

    const handleCopy = async () => {
        if (!activeCard || activeCard.modal !== true || !activeCard.cupom) return;
        try {
            await navigator.clipboard.writeText(activeCard.cupom);
            setCopied(true);
            window.setTimeout(() => setCopied(false), 1800);
        } catch {
            setCopied(false);
        }
    };

    return (
        <div className={styles.tainaraqquel}>
            <div className={styles.container}>
                <img src={perfil} alt="Tainá Raquel" className={styles.perfil} />
                <div className={styles.socialRow}>
                    <a href={`mailto:${EMAIL}`} className={styles.socialLink} aria-label="E-mail">
                        <svg
                            height="24"
                            width="24"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                            aria-hidden="true"
                        >
                            <path
                                fill={ICON_COLOR}
                                d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z"
                            />
                        </svg>
                    </a>
                    <a
                        href={TIKTOK_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.socialLink}
                        aria-label="TikTok"
                    >
                        <TiktokIcon height="22" color={ICON_COLOR} />
                    </a>
                    <a
                        href={INSTAGRAM_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.socialLink}
                        aria-label="Instagram"
                    >
                        <InstagramIcon height="24" color={ICON_COLOR} />
                    </a>
                    <a
                        href={`https://wa.me/${WHATSAPP_NUMBER}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.socialLink}
                        aria-label="WhatsApp"
                    >
                        <WhatsappIcon height="28" color={ICON_COLOR} />
                    </a>
                </div>
                <div className={styles.cards}>
                    {cardImages.map((card) =>
                        card.modal ? (
                            <button
                                type="button"
                                key={card.id}
                                className={styles.card}
                                onClick={() => setActiveCard(card)}
                                aria-label={`Abrir ${card.brand}`}
                            >
                                <img src={card.image} alt={card.brand} />
                            </button>
                        ) : (
                            <a
                                href={card.link}
                                target="_blank"
                                rel="noopener noreferrer"
                                key={card.id}
                                className={styles.card}
                            >
                                <img src={card.image} alt={card.brand} />
                            </a>
                        )
                    )}
                </div>
            </div>

            {activeCard ? (
                <div
                    className={styles.modalOverlay}
                    onClick={() => setActiveCard(null)}
                    role="presentation"
                >
                    <div
                        className={styles.modal}
                        role="dialog"
                        aria-modal="true"
                        aria-labelledby="tainaraqquel-modal-title"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button
                            type="button"
                            className={styles.modalClose}
                            onClick={() => setActiveCard(null)}
                            aria-label="Fechar"
                        >
                            ×
                        </button>

                        {activeCard.modal === 'contact' ? (
                            <>
                                <p className={styles.modalEyebrow}>Parcerias</p>
                                <h2 id="tainaraqquel-modal-title" className={styles.modalBrand}>
                                    {activeCard.brand}
                                </h2>
                                <div className={styles.contactActions}>
                                    <a
                                        href={`mailto:${activeCard.email}`}
                                        className={styles.contactBtnEmail}
                                    >
                                        <svg
                                            height="22"
                                            width="22"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                            aria-hidden="true"
                                        >
                                            <path
                                                fill="currentColor"
                                                d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5L4 8V6l8 5 8-5v2z"
                                            />
                                        </svg>
                                        <span>E-mail</span>
                                    </a>
                                    <a
                                        href={`https://wa.me/${activeCard.whatsapp}`}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={styles.contactBtnWhatsapp}
                                    >
                                        <WhatsappIcon height="22" color="currentColor" />
                                        <span>WhatsApp</span>
                                    </a>
                                </div>
                            </>
                        ) : (
                            <>
                                <p className={styles.modalEyebrow}>
                                    {activeCard.cupom ? 'Cupom exclusivo' : 'Em breve'}
                                </p>
                                <h2 id="tainaraqquel-modal-title" className={styles.modalBrand}>
                                    {activeCard.brand}
                                </h2>
                                {activeCard.cupom ? (
                                    <div className={styles.cupomBox}>
                                        <span className={styles.cupomLabel}>Seu cupom</span>
                                        <span className={styles.cupomCode}>{activeCard.cupom}</span>
                                        <button
                                            type="button"
                                            className={styles.copyBtn}
                                            onClick={handleCopy}
                                        >
                                            {copied ? 'Copiado' : 'Copiar cupom'}
                                        </button>
                                    </div>
                                ) : (
                                    <div className={styles.cupomBoxEmpty}>
                                        <span className={styles.cupomLabel}>Cupom</span>
                                        <span className={styles.cupomEmptyText}>Cupom em breve</span>
                                    </div>
                                )}
                                {activeCard.site ? (
                                    <a
                                        href={activeCard.site}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className={styles.siteBtn}
                                    >
                                        Ir para o site
                                    </a>
                                ) : null}
                            </>
                        )}
                    </div>
                </div>
            ) : null}
        </div>
    );
};

export default Tainaraqquel;
